import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { SignIn } from '@phosphor-icons/react';
import { adminSignIn } from '../lib/api';
import { toast } from 'sonner';

const AdminLogin = ({ onLogin }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const session = await adminSignIn(formData.email.trim(), formData.password);
      onLogin(session);
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 pt-16"
      data-testid="admin-login-page"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <div className="bg-secondary border border-border/40 rounded-sm p-8">
          <div className="text-center mb-8">
            <h1 className="font-heading font-black text-3xl text-foreground tracking-tight mb-2">
              Admin Login
            </h1>
            <p className="text-muted-foreground">Sign in to manage your store</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-foreground mb-2">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full bg-background border border-border/40 rounded-sm px-4 py-3 text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-white/50 transition-colors"
                placeholder="admin@posterly.com"
                required
                data-testid="admin-email-input"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-foreground mb-2">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="w-full bg-background border border-border/40 rounded-sm px-4 py-3 text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-white/50 transition-colors"
                placeholder="Enter your password"
                required
                data-testid="admin-password-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-white text-black py-3 px-6 rounded-sm font-medium flex items-center justify-center gap-2 hover:bg-white/90 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              data-testid="admin-login-button"
            >
              {loading ? (
                'Signing in...'
              ) : (
                <>
                  <SignIn size={20} weight="bold" />
                  Sign In
                </>
              )}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
